import { render, staticRenderFns } from "./DetailRequestWithdrawOffExchange.vue?vue&type=template&id=7d80980e&scoped=true&"
import script from "./DetailRequestWithdrawOffExchange.vue?vue&type=script&lang=js&"
export * from "./DetailRequestWithdrawOffExchange.vue?vue&type=script&lang=js&"
import style0 from "./DetailRequestWithdrawOffExchange.vue?vue&type=style&index=0&id=7d80980e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80980e",
  null
  
)

export default component.exports